<template>
  <div>
    <!-- <current-path /> -->
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.flight_forms") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
    </v-toolbar>
    <v-container fluid class="filter-area">
      <v-row>
        <v-col cols="12" sm="6" class="d-flex">
          <global-toggle-filter
            :queries="toggleQueryies"
            ref="toggle_filter_ref"
          />
        </v-col>

        <v-col cols="12" sm="6" class="d-flex justify-end">
          <v-btn @click="ClearAllFilters" class="error">{{
            $t("button.reset")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <!-- table -->
    <wrapping-table
      @on_dialog_close="onDialogClose"
      @get_items="getItems"
      ref="table_ref"
      :headersName="headers"
      pathName="flight-forms"
      resName="flight_forms"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          {{ item.passport_number ? item.passport_number : "---" }}
        </td>
        <td class="text-sm-center">
          {{ item.from ? item.from : "--" }}
        </td>
        <td class="text-sm-center">{{ item.to ? item.to : "---" }}</td>
        <td class="text-sm-center">
          {{ item.phone ? item.phone.number : "---" }}
        </td>
        <td class="text-sm-center">
          {{ convertDateAndTime(item.created_at) }}
        </td>
        <td class="text-sm-center">
          {{ item.travel_at ? convertDateAndTime(item.travel_at) : "---" }}
        </td>
        <td class="text-sm-center">
          {{ item.returns_at ? convertDateAndTime(item.returns_at) : "---" }}
        </td>
        <td class="text-sm-center">
          <v-chip v-if="item.closed" class="error">
            {{ $t("labels.closed") }}
          </v-chip>
          <v-chip v-if="item.seen" class="success">
            {{ $t("labels.seen") }}
          </v-chip>
          <v-chip v-if="!item.seen && !item.closed" class="warning">
            {{ $t("labels.pending") }}
          </v-chip>
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleShow(item, index)"
            :title="$t('icon.show')"
            small
            >mdi-eye</v-icon
          >
          <v-icon
            @click="handleDelete(item, index)"
            :title="$t('icon.delete')"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog_header">{{
          $t("headings.contact_details")
        }}</v-card-title>
        <v-card-text>
          <v-list flat>
            <v-list-item v-if="item.passport_number">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.passport_number") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item ? item.passport_number : "---" }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-if="item.from">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.from") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item ? item.from : "---" }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-if="item.to">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.to") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item ? item.to : "---" }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-if="item.phone && item.phone.number">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.phone") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.phone && item.phone.number }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>

     <v-list-item v-if="item.frequent_flyer_number">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.frequent_flyer_number") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.frequent_flyer_number }}
              </v-list-item-action>
            </v-list-item>


            <v-divider></v-divider>

      </v-list-item>
     <v-list-item v-if="item.infant_count">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.infant_count") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.infant_count }}
              </v-list-item-action>
            </v-list-item>


            <v-divider></v-divider>

  <v-list-item v-if="item.adult_count">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.adult_count") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.adult_count }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
 <v-list-item v-if="item.child_count">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.child_count") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.child_count }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-if="item.ticket_type">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.ticket_type") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.ticket_type }}
              </v-list-item-action>
            </v-list-item>
         <v-divider></v-divider>
            <v-list-item v-if="item.has_special_request">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.special_request_details") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && item.special_request_details }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.created_at") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item && convertDateAndTime(item.created_at) }}
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item v-if="item.travel_at">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.travel_at") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item ? convertDateAndTime(item.travel_at) : "---" }}
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item v-if="item.returns_at">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.return_at") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ item ? convertDate(item.returns_at) : "---" }}
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item v-if="item.passport_image">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("table.passport_image") }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-img :src="item.passport_image.path" width="300px" contain />
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
      </template>
      <!-- dilaog -->
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
import cookie from "js-cookie";
import { ShowData, UpdateData, IndexData } from "@/helpers/apiMethods";
export default {
  name: "FlightForms",

  data() {
    return {
      headers: [
        "passport_number",
        "from",
        "to",
        "phone",
        "created_at",
        "travel_at",
        "return_at",
        "status",
        "actions"
      ],

      isEdit: false,
      loadingButton: false,
      items: [],
      item: {},
      itemIndex: "",
      locale: cookie.get("language") || "en",
      queries: {
        query: {
          user_name: "",
          user_email: "",
          user_phone: ""
        }
      },
      toggleQueryies: {
        query: {
          seen: "",
          closed: ""
        }
      },
      topics: [],
      topic: ""
    };
  },
  methods: {
    handleFitler(name) {
      const queries = {};
      queries[name] = this[name];
      if (queries[name] === "") {
        delete queries[name];
        queries[name] = "";
      }
      if (queries[name] !== "") {
        this.$router.push({ query: { ...this.$route.query, ...queries } });
      }
    },
    hadnleGetTopics() {
      IndexData({ reqName: "topics" })
        .then((res) => {
          const { data } = res.data;
          this.topics = data;
        })
        .catch((err) => console.log(err));
    },
    ClearAllFilters() {
      this.$refs.toggle_filter_ref.ClearFilter();
      this.$router.push({ query: {} });
    },
    handleStatus(status) {
      switch (status) {
        case false:
          return this.$t("labels.pending");

        case true:
          return this.$t("labels.seen");
      }
    },
    onDialogClose() {
      this.isEdit = false;
      this.$refs.table_ref.handleGetItems(this.$route.query);
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleShow(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.$refs.table_ref.toggleDialog();
      this.handleShowData();
    },
    getItems(items) {
      this.items = items;
    },
    handleUpdate() {
      this.loadingButton = true;
      const data = { closed: "closed", _method: "put", locale: this.locale };

      UpdateData({
        reqName: "contact-messages",
        data,
        param: this.item.id
      })
        .then(() => {
          this.$refs.table_ref.toggleDialog();
          this.onDialogClose();
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loadingButton = false));
    },
    handleShowData() {
      ShowData({ reqName: "flight-forms", param: this.item.id })
        .then((res) => {
          const { flight_form } = res.data;
          this.item = flight_form;
        })
        .catch((err) => console.log(err));
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.hadnleGetTopics();
        if (query["topic"]) {
          this["topic"] = Number(query["topic"]);
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
.Pending {
  background-color: darkorange !important;
}
.Seen {
  background-color: darkgreen !important;
}
.Closed {
  background-color: darkred !important;
}
.Pending,
.Seen,
.Closed {
  color: #fff !important;
  box-shadow: 0 1px 5px #444 !important;
}
</style>
